import { EnvironnementManager, GetVisionCommand, MyAppsCommand, ViewData } from '@wizeoo/akm-common-lib';
import { Injectable } from '@angular/core';
import { WIZ_COMMAND_STATE, WizCoreTranslationManager } from '@wizeoo/akm-core-lib';
import { WizCommand, WizGroupCommand, WizTranslationManager } from '@wizeoo/akm-component-lib';
import { KeycloakService } from 'keycloak-angular';
import { RoleCmd } from '@wizeoo/akm-common-lib';
import { FeatureCmd } from '@wizeoo/akm-common-lib';
import { Model } from '../model/model';
import { BuCmd } from '@wizeoo/akm-common-lib';
import { CountryCmd } from '@wizeoo/akm-common-lib';
import { LanguageCmd } from '@wizeoo/akm-common-lib';
import { UserInfoCmd } from '@wizeoo/akm-common-lib';
import { TRANSRESOURCES } from 'src/assets/locales/trans-resources';
import { Vision } from '@wizeoo/akm-message-lib';

import { DeviceService } from 'src/app/services/device.service';



// import { environment } from 'src/environments/environment';
/**
 * service d'initialisation des données de base de l'application.
 * Cette fonctionnalité est appelée avant l'entrée réelle dans l'application (après login)
 */
@Injectable()
export class AppInitializer {
  /**
   * Marks that the application has been initialized
   */
  private _isInitialized: boolean = false;

  public get isInitialized(): boolean {
    return this._isInitialized;
  }

  /**
   * Etat mobile detecte au demarrage de l'application.
   * La valeur est exposee via un getter pour conserver la meme logique
   * que les autres etats d'initialisation, puis elle est copiee dans le
   * modele global afin que les vues puissent l'utiliser sans relancer la detection.
   */
  private _isMobile: boolean = false;

  public get isMobile(): boolean {
    return this._isMobile;
  }

  /**
   * Etat iPhone avec ecran arrondi/notch detecte au demarrage.
   * Il complete isMobile pour les ajustements d'affichage lies aux safe areas.
   */
  private _isIphoneRounded: boolean = false;

  public get isIphoneRounded(): boolean {
    return this._isIphoneRounded;
  }

  constructor(private security: KeycloakService,
  private deviceService: DeviceService) {
  }

  /**
   * Initialisation des données de bases.
   */
  public async init() {
    let mod: Model = Model.getInstance();
    
    const isLoggedIn = await this.security.isLoggedIn();
    // injection de la ref keycloak dans le modèle
    mod.security = this.security; 
    
    // chargement de l'environnement
    await EnvironnementManager.checkEnvConfig().then(
      async response => { return Promise.resolve()}
    );

    if (isLoggedIn) {

      // résolution du context donné dans l'URL
      // Gestion du hash si useHash à true dans la config Routing
      const url: URL = new URL(window.location.href?.replace('#', '/'));
      let bu: string = url.searchParams.get('bu');
      const domain: string = window.location.hostname.split('.')[0];
      // const domain: string = url.searchParams.get('domain');
      let vision: string = url.searchParams.get('vision');

      // mode PROD
      bu = 'TEXDECOR';
      vision = 'SOURCING';

      // mode local
      // bu = 'TEX';
      // vision = 'POC';

      mod.domainCode = domain.toUpperCase();
      mod.businessUnitCode = bu ? bu.toUpperCase() : domain.toUpperCase();
      mod.visionEngine.selectVision(vision ? vision.toUpperCase() : ViewData.defaultVision);

      return new Promise((resolve, reject) => {

  // Lecture de l'etat courant calcule par DeviceService avant le chargement
  // des donnees utilisateur, pour que le modele soit disponible des l'entree
  // dans l'application.
  this._isMobile = this.deviceService.isMobile();
  this._isIphoneRounded = this.deviceService.isIphoneRounded();

  // Propagation dans le singleton Model : les vues et composants qui dependent
  // du contexte device disposent d'une source commune pendant l'initialisation.
  mod.isMobile = this.isMobile;
  mod.isIphoneRounded = this.isIphoneRounded;

 // console.log('is mobile =', mod.isMobile);
 // console.log('is iphone rounded =', mod.isIphoneRounded);

  new UserInfoCmd(mod)
        
        // la promesse
        // chargement du user dans un premier temps
        new UserInfoCmd(mod)
          .getUserInfo((pCmd: UserInfoCmd) => {
            if (pCmd.state === WIZ_COMMAND_STATE.FAULT) {
              console.log('UserInfoCmd error', pCmd);
              reject();
              return;
            }

            // injection des trads spécifiques au projet
            WizCoreTranslationManager.getInstance().moreTrads = TRANSRESOURCES as any;
            // chargement des trads du projet
            WizTranslationManager.getInstance().loadTranslations(mod.currentLocaleCode);



            const calls = [];
            calls.push(new CountryCmd(mod).find()); // les pays
            calls.push(new LanguageCmd(mod).find()); // les langues
            calls.push(new BuCmd(mod).find()); // On charge les BUs du domaine pour la résolution des rôles
            calls.push(new FeatureCmd(mod).findWildCardDomain()); // chargement des features génériques
            calls.push(new RoleCmd(mod).findWildcard());
            calls.push(new FeatureCmd(mod).find()); // chargement des features génériques
            calls.push(new RoleCmd(mod).find());
            calls.push(new MyAppsCommand(mod).findAllVisions());

            let v: Vision = new Vision();
            v.domain = mod.domainCode;
            v.businessUnitCode = mod.businessUnitCode;
            v.code = mod.visionCode;
            calls.push(new GetVisionCommand(mod).get(v));

            calls.push(new UserInfoCmd(mod).setUserTimeStamp()); // maj des infos de ts sur le userApp de la vision

            new WizGroupCommand()
              .configure(calls, (cmd: WizGroupCommand) => {
                // retour de la 1ère pile d'appel, il faut une BU
                if (cmd.state === WIZ_COMMAND_STATE.SUCCESS) {
                  resolve(null);
                } else {
                  let errorMsg = 'unknown';
                  cmd.commandPile.forEach((sub: WizCommand<any>) => {
                    if(sub.result === WIZ_COMMAND_STATE.FAULT) {
                      errorMsg = sub.error.message;
                    }
                  });
                  reject(errorMsg)
                }
              }, false)
              .execute(); // lancement de la 1ère groupCommand (BU)
          })
          .execute(); // fin getUserInfo
      }); // fin de promesse
    } else {
      console.log('not logged', Model.getInstance().connectedUser);
      return Promise.reject();
    }
  }
}
